import { clsx } from 'clsx'
import { ReactNode } from 'react'
import { CheckIcon } from '@st/theme'

export function ClientCard({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div className={clsx('mx-auto w-full', className)}>
      <div className="w-full rounded-lg border border-gray-200 bg-white p-6 shadow-md">
        {children}
      </div>
    </div>
  )
}

export function ClientCardStepHeading({
  stepNumber,
  completed,
  title,
  status,
  action
}: {
  stepNumber: number
  completed?: boolean
  title: ReactNode
  status?: ReactNode
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 items-center gap-4">
        <div
          className={clsx(
            'inline-flex size-12 flex-shrink-0 items-center justify-center rounded-full border',
            completed
              ? 'border-green-400 bg-green-400 text-green-800'
              : 'border-gray-300 bg-white text-lg font-medium text-gray-800'
          )}
        >
          {completed ? <CheckIcon className="size-4" /> : stepNumber}
        </div>
        <div className="min-w-0 space-y-1">
          <div>{title}</div>
          {status ? <div className="text-base text-gray-500">{status}</div> : null}
        </div>
      </div>

      {action ? (
        <div className="flex w-full flex-shrink-0 sm:w-auto sm:justify-end [&>*]:w-full sm:[&>*]:w-auto">
          {action}
        </div>
      ) : null}
    </div>
  )
}

type DocumentChecklistItemProps = {
  title: string
  description?: string
  buttons?: ReactNode
  className?: string
  completed?: boolean
  faded?: boolean
}
export function DocumentChecklistItem({
  title,
  description,
  buttons,
  completed,
  faded,
  className
}: DocumentChecklistItemProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-start justify-between gap-3 border-b border-gray-200 py-4 sm:flex-row sm:items-center',
        faded && 'opacity-50',
        className
      )}
    >
      <div className="flex w-full min-w-0 flex-grow items-center gap-3">
        <span
          className={clsx(
            'flex size-6 flex-shrink-0 items-center justify-center rounded-full border-2',
            completed ? 'border-green-500 bg-white text-green-500' : 'border-gray-300 bg-white'
          )}
        >
          {completed ? <CheckIcon className="size-4" /> : null}
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <span className="truncate text-base font-semibold leading-5 text-gray-900">{title}</span>
          <span className="truncate text-base leading-4 text-gray-500">{description}</span>
        </div>
      </div>

      <div className="flex w-full min-w-0 justify-end sm:ml-3 sm:w-auto sm:min-w-0 sm:flex-shrink md:flex-shrink-0">
        {buttons}
      </div>
    </div>
  )
}
